module.exports = __webpack_public_path__ + "img/Profiles.37cee890.svg";